module.exports = __webpack_public_path__ + "static/media/Pool-Logo.fac734b1.svg";